var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewTable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6639 0H2.66388C1.56388 0 0.663879 0.9 0.663879 2V16C0.663879 17.1 1.56388 18 2.66388 18H17.6639C18.7639 18 19.6639 17.1 19.6639 16V2C19.6639 0.9 18.7639 0 17.6639 0ZM12.6639 16H7.66388V5H12.6639V16ZM2.66388 5H5.66388V16H2.66388V5ZM14.6639 16V5H17.6639V16H14.6639Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6639 0H2.66388C1.56388 0 0.663879 0.9 0.663879 2V16C0.663879 17.1 1.56388 18 2.66388 18H17.6639C18.7639 18 19.6639 17.1 19.6639 16V2C19.6639 0.9 18.7639 0 17.6639 0ZM12.6639 16H7.66388V5H12.6639V16ZM2.66388 5H5.66388V16H2.66388V5ZM14.6639 16V5H17.6639V16H14.6639Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTable);
export default __webpack_public_path__ + "static/media/viewTable.32fea076fda0d1d53b4695f2da67efb9.svg";
export { ForwardRef as ReactComponent };